@if (isLoading) {
  <motn-spinner></motn-spinner>
}

@if (!isLoading && groupedTiles) {
  @if (hasNoMatchingGroups) {
    <div class="empty-state-container">
      <i class="empty-state-icon fa-regular fa-magnifying-glass"></i>
      <p class="empty-state-text">{{ matchingTileIds ? 'No tiles match your search or filters' : 'No tiles in this app yet' }}</p>
    </div>
  } @else {
    @for (group of groupedTiles; track trackGroupBy(i, group); let i = $index) {
      @if (group.length > 0) {
        <div class="tile-group">
          @if (_groups[i] && !_groups[i].Ungrouped) {
            <h3>
              {{ _groups[i].Name }}
            </h3>
          }

          <div class="tile-grid">
            @for (tile of group; track tile.ID+$index) {
              @if (tile.Type === TILE_TYPE_SUPER_CANVAS) {
                <motn-canvas-tile-display
                  [tile]="tile"
                  [matchingTileIds]="matchingTileIds"
                ></motn-canvas-tile-display>
              } @else if (tile.Type === TILE_TYPE_SUPER_FOLDER) {
                <motn-tile-folder
                  [tile]="tile"
                  [matchingTileIds]="matchingTileIds"
                ></motn-tile-folder>
              } @else {
                <motn-tile
                  [rawTile]="tile"
                  [ngClass]="{'shrinkHeight': isDataPointsView(tile)}"
                ></motn-tile>
              }
            }
          </div>
        </div>
      }
    }
  }
}
